/**
 * @desc
 * - Renders a pretty component telling the user that there aren't any results.
 * - You must specify a configuration in the cs-empty-state attribute/directive
 * @example
 * "appVulns" is the configuration name
 * <div cs-empty-state="'appVulns'"></div>
 */
;(function () {
  'use strict'

  angular
    .module('contrast.empty-state')
    .directive('csEmptyState', [csEmptyState])

  function csEmptyState() {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      scope: {
        configKey: '='
      },
      bindToController: true,
      templateUrl: 'views/cs-empty-state.html',
      controller: 'csEmptyStateCtrl',
      controllerAs: 'csEmptyStateCtrl'
    }
  }
})()
